import Page from '../../../shared/components/Page/Page';
import {useEffect, useState} from "react";
import {Form, Table, Tag} from "antd";
import ReadMoreText from "../../../shared/components/ReadMoreText";
import {formatDateTime} from "../../../shared/utils/helpers";
import { adminGetLogs as getLogs } from "../api";
import Search from "../../../shared/components/Search/Search";
import { searchPartner } from "../../partner/api";
import dayjs from "dayjs";

function Hook() {
    const [tableLoading,setTableLoading] = useState(false);
    const [form] = Form.useForm();
    const [dataSource,setDataSource] = useState([]);
    const [options,setOptions] = useState([]);
    const [query,setQuery] = useState('');
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
        search: {
            createdAt: [dayjs().startOf('day'), dayjs().endOf('day')]
        }
    });

    const items = [
        {
            name: 'uuid',
            type: 'text',
            placeholder: 'ID'
        },
        {
            name: 'userId',
            type: 'search',
            placeholder: 'Nhập tên đối tác',
            options: options,
            onSearch: (value) => {
                setQuery(value)
            }
        },
        {
            name: 'createdAt',
            type: 'date',
            placeholder: 'Thời gian'
        }
    ];

    const columns = [
        {
            title: 'ID',
            dataIndex: 'uuid',
            align: 'center'
        },
        {
            title: 'Đối tác',
            dataIndex: 'partnerName',
            align: 'center',
            render: (value) => {
                return <Tag>{value}</Tag>
            }
        },
        {
            title: 'Đường dẫn',
            dataIndex: 'webhookUrl'
        },
        {
            title: 'Mã code',
            dataIndex: 'statusCode',
            align: 'center',
            render: (value) => {
                if (value >= 200 && value <= 299) {
                    return <Tag color={'green'}>{value}</Tag>
                }
                return <Tag color={'red'}>{value}</Tag>
            }
        },
        {
            title: 'Kiểu',
            dataIndex: 'httpVerb',
            align: 'center',
            render: (value) => {
                return <Tag color={'blue'}>{value}</Tag>
            }
        },
        {
            title: 'Nội dung lỗi',
            dataIndex: 'errorMessage'
        },
        {
            title: 'Loại lỗi',
            dataIndex: 'errorType',
            align: 'center'
        },
        {
            title: 'Dữ liệu gửi',
            dataIndex: 'payload',
            render: (value) => {
                return <ReadMoreText text={JSON.stringify(value)} maxLength={50}/>
            }
        },
        {
            title: 'Thời gian',
            dataIndex: 'createdAt',
            sorter: true,
            align: 'center',
            render: (value) => {
                return formatDateTime(value)
            }
        }
    ];

    const fetchPartners = async () => {
        const response = await searchPartner(query);
        if (response.success) {
            const data = response.data.map(item => ({
                value: item.userId,
                text: item.name
            }));
            setOptions(data)
        }
    }

    const fetchData = async () => {
        setTableLoading(true);
        const response = await getLogs(tableParams);
        if (response.success) {
            setDataSource(response.data.data);
            setTableParams({
                ...tableParams,
                pagination: {
                    ...tableParams.pagination,
                    total: response.data.total
                },
            });
        }
        setTableLoading(false);
    }

    const handleSearch =  () => {
        const params = form.getFieldsValue();
        setTableParams({
            ...tableParams,
            search: {
                ...params
            }
        })
    }

    const handleTableChange = (pagination, filters, sorter) => {
        setTableParams({
            ...tableParams,
            pagination,
            filters,
            sorter,
        });
    };

    useEffect(() => {
        fetchData().finally();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tableParams.pagination?.current,
        tableParams.pagination?.pageSize,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        JSON.stringify(tableParams.sorter),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        JSON.stringify(tableParams.search),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        JSON.stringify(tableParams.filters),
    ]);

    useEffect(() => {
        fetchPartners();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query])
    return (
        <Page title="Lịch sử hook">
            <Search
                form={form}
                items={items}
                onSearch={handleSearch}
            />
            <Table
                columns={columns}
                dataSource={dataSource}
                bordered={true}
                onChange={handleTableChange}
                loading={tableLoading}
                pagination={tableParams.pagination}
                scroll={{
                    x: 2200,
                }}
            />
        </Page>
    )
}

export default Hook;
